import { Size } from '../enums/size.enum';
import { BraSize, convertToBraObject } from './bra-helper';
import { replaceOutliersWithUndefinedFor3SizeArray } from './size-calculator';

export const calculateWaistHeroSize = (dress: number | undefined, dressOther: number | undefined, waist: number | undefined, bra: BraSize | undefined) => {
  // Dress Size //
  const combinedDressSize = dress !== undefined ? dress + 0.25 * (dressOther ?? 0) : undefined;
  const rawDressGarmentSize = combinedDressSize ? combinedDressSize / 2.4106 : undefined;

  // Waist Size //
  const rawWaistGarmentSize = waist ? (waist - 20.298) / 2.9197 : undefined;

  // Bra Size //
  const braBand = convertToBraObject(bra)?.band ?? 0;
  const p0 = 113.23808198;
  const p1 = -9.069471283 * braBand;
  const p2 = 0.28179634 * braBand ** 2;
  const p3 = -0.002549112 * braBand ** 3;
  const waistBandBraSize = p3 + p2 + p1 + p0;

  const rawWaistGarmentSize2 = (waistBandBraSize - 20.298) / 2.9197;

  const [dressGarmentSize, waistGarmentSize, waistGarmentSize2] = replaceOutliersWithUndefinedFor3SizeArray([
    rawDressGarmentSize,
    rawWaistGarmentSize,
    rawWaistGarmentSize2,
  ]);

  const dressWeight = dressGarmentSize === undefined ? 0 : 0.38;
  const waistWeight = waistGarmentSize === undefined ? 0 : 0.31;
  const waist2Weight = waistGarmentSize2 === undefined ? 0 : 0.31;

  const totalWeight = dressWeight + waistWeight + waist2Weight;

  const weightedDressWeight = dressGarmentSize !== undefined && dressWeight ? dressGarmentSize * (dressWeight / totalWeight) : 0;
  const weightedWaistWeight = waistGarmentSize !== undefined && waistWeight ? waistGarmentSize * (waistWeight / totalWeight) : 0;
  const weightedWaist2Weight = waistGarmentSize2 !== undefined && waist2Weight ? waistGarmentSize2 * (waist2Weight / totalWeight) : 0;

  const finalWeightedSize = Math.round(weightedDressWeight + weightedWaistWeight + weightedWaist2Weight);

  if (finalWeightedSize < 1) return Size.XS;
  if (finalWeightedSize > 8) return Size['3X'];

  switch (finalWeightedSize) {
    case 1:
      return Size.XS;
    case 2:
      return Size.S;
    case 3:
      return Size.M;
    case 4:
      return Size.L;
    case 5:
      return Size.XL;
    case 6:
      return Size['1X'];
    case 7:
      return Size['2X'];
    case 8:
    default:
      return Size['3X'];
  }
};
